export default __webpack_public_path__ + "static/23-10e50011ea3a4d555fcfc20cf8183d29.png";